// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2rwS_","description":"MealItem_description__2ZUJt","price":"MealItem_price__27Wqa"};